'use client';

import React from 'react';
import { Provider } from 'react-redux';
import { store } from '@/shared/providers/store';

interface StoreProviderProps {
  children: React.ReactNode;
}

// Redux Provider wrapper for the app.
export function StoreProvider({ children }: StoreProviderProps) {
  return <Provider store={store}>{children}</Provider>;
}

export default StoreProvider;

